import React from 'react';
import { passwordChecks } from '../utils/passwordPolicy';

// Live "does it meet the rule yet" list under a new-password field.
// Inline styles on purpose: no stylesheet to keep in styles/pageStyles.js.
export default function PasswordChecklist({ password }) {
  const checks = passwordChecks(password);
  return (
    <ul
      aria-label="Password requirements"
      style={{ listStyle: 'none', margin: '6px 0 10px', padding: 0, fontSize: 'var(--font-size-xs, 12px)', textAlign: 'left' }}
    >
      {checks.map((c) => (
        <li
          key={c.label}
          style={{ color: c.ok ? 'var(--color-success, #1a7f37)' : 'var(--color-text-muted, #8b949e)', lineHeight: 1.6 }}
        >
          <span aria-hidden="true" style={{ display: 'inline-block', width: '1.4em' }}>{c.ok ? '✓' : '○'}</span>
          {c.label}
          <span style={{ position: 'absolute', left: -9999 }}>{c.ok ? ' (done)' : ' (not yet)'}</span>
        </li>
      ))}
    </ul>
  );
}
